var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"flex flex-wrap"},_vm._l((_vm.items),function(ref,index){
var name = ref.name;
var value = ref.value;
var disabled = ref.disabled;
var mainLock = ref.mainLock;
var hub = ref.hub;
return _c('li',{key:value,staticClass:"item"},[_c('binary-input',{staticClass:"w-full",attrs:{"value":_vm.booleans[index],"label":name,"disabled":disabled},on:{"input":function($event){return _vm.click(index)}}},[(!mainLock || !hub)?_c('span',{staticClass:"text-xs"},[_c('i',{staticClass:"inline-block align-middle fas fa-exclamation-triangle text-gray-600 mr-2"})]):_vm._e(),_c('span',{staticClass:"default-text"},[_vm._v(_vm._s(name))])])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }